/*
 * Copyright (c) 2021.  Blacksheepz media B.V.
 * https://www.blacksheepz-media.com
 * Ramon van Ophuizen
 */

import React, {useEffect, useState} from "react";
import Button from '@material-ui/core/Button';
import {Grid, FormGroup, FormLabel, Typography} from "@material-ui/core";
// import Alert from '@material-ui/lab/Alert';
import ReactPlayer from "react-player";
import {withTranslation} from "react-i18next";
import ReactHtmlParser from "react-html-parser";
import PopUpComponent from "../../components/Nav/PopUpComponent";
import PhotoComponent from "../../components/Photo/PhotoComponent";
// import PhotoCropComponent from "../../components/Photo/PhotoCropComponent";
import QuantityControl from "../../components/QuantityControl";
// import EffectComponent from "../../components/Photo/EffectComponent";
import {useThemeData} from "../../context/ThemeDataContext";
import ProductColorSelector from "../ProductColorSelector";
import GreenScreenComponent from "../Photo/GreenScreenComponent";
import ProductProperties from "./ProductProperties";
import ProductPrintType from './ProductPrintType';

function ProductdetailComponent(props) {
    // const {bijsnijden_fotos} = useThemeData().modules;
    const {videos_active, hide_category_side_bar} = useThemeData().modules;
    const {primary_color_2, font_family_button, background_color_2, primary_color_4} =
        useThemeData().themeData.site.theme;
    const {site_id} = useThemeData().themeData.site;
    const productVariation = props.productVariation;
    const printType = props.printType;

    // const getFirstImage = (variationObject) => {
    //     for (const key in variationObject) {
    //         if (variationObject.hasOwnProperty(key)) {
    //             const variation = variationObject[key];
    //             if (variation.variationImage) {
    //                 return variation.variationImage; // returns the first non-null image found
    //             }
    //         }
    //     }
    //     return null; // return null if no image is found
    // };

    //const variationProductImage = getFirstImage(groupVariations);

    // get colors of product and select default of dropdown menu.
    const colors = props.product_colors !== null ? props.product_colors.split(";") : null;
    let color = 'Kleur';
    if (colors !== null) {
        if (colors.length === 1) {
            color = colors[0]
        } else {
            color = 'Kleur';
        }
    }

    const [product_color, setProductColor] = useState(color);
    const [messages, setMessages] = useState({
        message: false,
        messageCrop: false,
        messageFiles: false,
        messageVideo: false,
    });


    const [photo_files, setPhotoFiles] = useState({
        photo_id: props.photo_id,
        photo_file_name: null,
        file_changed: true,
    });

    const [effects, setEffects] = useState({
        effect_id: 0,
        effect_file_name: null,
        voor_achter: null,
    });

    const [effectFor, setEffectFor] = useState({
        effect_for_id: 0,
        effect_for_file_name: null,
        voor_achter: null,
    });

    // const fileNameSplit = props.photo_file_name.split(".");

    useEffect(() => {
        if (props.product_type !== "pakket") {
            let newName = props.file_changed;
            if (photo_files.file_changed !== newName) {
                setPhotoFiles((prevState) => ({...prevState, file_changed: newName}));
            }
        }
    }, [props.file_changed, photo_files.file_changed, props.product_type]);

    // useEffect(() => {
    //   if (!props.product_colors || props.product_colors === null) {
    //     setShow("hide");
    //   } else {
    //     setShow("show");
    //   }
    // }, [props.product_colors]);

    const closePopup = (photofile_name, photoid) => {
        setMessages((prevState) => ({
            ...prevState,
            message: false,
            messageCrop: false,
            messageFiles: false,
            messageVideo: false,
        }));
        if (photofile_name) {
            setPhotoFiles((prevState) => ({
                ...prevState,
                photo_id: photoid,
                photo_file_name: photofile_name,
            }));
            if (
                photofile_name !== photo_files.photo_file_name &&
                photo_files.photo_file_name !== null
            ) {
                setPhotoFiles((prevState) => ({
                    ...prevState,
                    photo_id: photoid,
                    photo_file_name: photofile_name,
                    file_changed: !photo_files.file_changed,
                }));
            }
        }
    };

    const closepopup_effect = (effect_png_src, effect_id, voor_achter) => {
        setMessages((prevState) => ({
            ...prevState,
            message: false,
            messageCrop: false,
            messageFiles: false,
            messageVideo: false,
        }));

        if (effect_png_src && effect_id !== 'backdropClick' && effect_id !== undefined) {
          if(voor_achter==='voor') {
              setEffectFor((prevState) => ({
                  ...prevState,
                  effect_for_file_name: effect_png_src,
                  effect_for_id: effect_id,
                  voor_achter: voor_achter,
              }));
          }else{
              setEffects((prevState) => ({
                  ...prevState,
                  effect_file_name: effect_png_src,
                  effect_id: effect_id,
                  voor_achter: voor_achter,
              }));
          }
            props.fileNameEffect(effect_png_src);
            props.fileIdEffect(effect_id);
            props.typeEffect(voor_achter);
            if (
                effect_png_src !== effects.effect_file_name &&
                effects.effect_file_name !== null
            ) {
                if(voor_achter==='voor') {
                    setEffectFor((prevState) => ({
                        ...prevState,
                        effect_for_file_name: effect_png_src,
                        effect_for_id: effect_id,
                        voor_achter: voor_achter,
                    }));
                }else{
                    setEffects((prevState) => ({
                        ...prevState,
                        effect_file_name: effect_png_src,
                        effect_id: effect_id,
                        voor_achter: voor_achter,
                    }));
                }
                setPhotoFiles((prevState) => ({
                    ...prevState,
                    file_changed: !photo_files.file_changed,
                }));
                props.fileNameEffect(effect_png_src);
                props.fileIdEffect(effect_id);
                props.typeEffect(voor_achter);
            }
        }else{
            setEffectFor((prevState) => ({
                ...prevState,
                effect_for_file_name: null,
                effect_for_id: 0,
                voor_achter: null,
            }));
            setEffects((prevState) => ({
                ...prevState,
                effect_file_name: null,
                effect_id: 0,
                voor_achter: null,
            }));
            props.effectClear();
        }

    };


  // useEffect(() => {
  //   if(type_effect==='voor'){
  //     setEffectFileNameFor(effect_file_name);
  //     setEffectFileIDFor(effect_file_id);
  //   }else{
  //     setEffectFileNameBehind(effect_file_name);
  //     setEffectFileIDBehind(effect_file_id);
  //   }
  // }, [effect_file_name, effect_file_id, type_effect]);


    const handleColorChangePhoto = (event) => {
        if (props.product_type === "pakket") {
            setProductColor(event.target.value);
        } else {
            setPhotoFiles((prevState) => ({
                ...prevState,
                photo_file_name: photo_files.photo_file_name,
            }));
            setProductColor(event.target.value);
        }
    };

    // const handleVariationChangePhoto = (updatedProperties) => {
    //     console.log("Received updated properties:", updatedProperties);
    //     //
    //     // setGroupVariations(prevState => {
    //     //     // Ensure we are combining objects correctly
    //     //     const combinedProperties = typeof updatedProperties === 'object' && updatedProperties !== null
    //     //         ? { ...prevState, ...updatedProperties }
    //     //         : { ...prevState };
    //     //
    //     //     console.log("Combined Group Variations:", combinedProperties);
    //         props.productVariation(updatedProperties);
    //
    //         // return combinedProperties;
    //     // });
    // };

    // useEffect(() => {
    //     console.log(groupVariations);
    //     props.productVariation(groupVariations);
    // }, [groupVariations, props]);

    const initialQuantity = props.quantity.length > 0
        ? props.quantity.find((q) => q.product_id === props.product_id) !== undefined
            ? props.quantity.quantity_value
            : 1
        : 1;

    const [quantity, setQuantity] = useState(initialQuantity);


    const changeQuantity = (event, productID, newQuantity) => {

        // console.log(newQuantity);

        setQuantity(newQuantity);
        let copyQuantity = Array.from(props.quantity);
        let quantities = new Set();

        // const dataQuantity = {
        //   product_id: productID,
        //   quantity_value: newQuantity,
        // };

        if (copyQuantity.length > 0) {
            // productID does not exists at all
            if (copyQuantity.find((q) => q.product_id === productID) === undefined) {
                // no product is matching, add a new product to current array
                const newDataQuantity = {
                    product_id: productID,
                    quantity_value: newQuantity,
                };
                quantities.add(newDataQuantity);
                quantities.add(...copyQuantity);

                // console.log(quantities);

            } else {
                const indexCopyQuantity = copyQuantity.findIndex((obj) => {
                    return obj.product_id === productID;
                });
                if (indexCopyQuantity !== -1) {
                    copyQuantity[indexCopyQuantity].quantity_value = newQuantity;
                }
                return copyQuantity;
            }
        } else {
            const firstDataQuantity = {
                product_id: productID,
                quantity_value: newQuantity,
            };
            quantities.add(firstDataQuantity);
        }

        let productsQuantities = Array.from(quantities);
        props.changeQuantity(productsQuantities);
    };

    if (props.product_type !== "pakket") {

        return (
            <div className="card-body-and-footer" style={{
                width: `100%`,
            }}>
                <Grid item lg={12} className="card-body">
                    <div>
                        <PhotoComponent
                            {...props}
                            photo_id={props.photo_id}
                            product_combivel_id={props.product_combivel_id}
                            photo_file_name={props.photo_file_name}
                            // variation_product_image={variationProductImage}
                            product_image={props.product_image}
                            login_name={props.login_name}
                            product_type={props.product_type}
                            product_id={props.product_id}
                            product_color={product_color}
                            folder_id={props.folder_id}
                            type={props.type}
                            photoType={props.photoType}
                            effect_file_name={effects.effect_file_name}
                            effect_id={effects.effect_id}
                            effect_file_id_for={effectFor.effect_for_id}
                            effect_voor_achter={effects.voor_achter}
                        />

                        {props.product_description && (
                            <Typography component="div" align="left">
                                {ReactHtmlParser(props.product_description)}
                            </Typography>
                        )}

                        {videos_active && props.product_video && (
                            <Button
                                style={{
                                    fontFamily: `${font_family_button}`,
                                    color: `${primary_color_2}`,
                                }}
                                className="btn btn-light align-around form-control btn-layout"
                                onClick={() =>
                                    setMessages((prevState) => ({
                                        ...prevState,
                                        messageVideo: !messages.messageVideo,
                                    }))
                                }
                            >
                                {props.t("shoppage:View video")}
                            </Button>
                        )}

                        {messages.messageVideo && (
                            <PopUpComponent
                                content={
                                    <div className="player-wrapper">
                                        <ReactPlayer url={props.product_video} width="100%" playing />
                                    </div>
                                }
                                btn2={props.t("Continue Shopping")}
                                closePopup={closePopup}
                            />
                        )}
                    </div>
                </Grid>

                <div className="card-footer background-effect card-border null5-margin-around">
                    <Grid container>
                        <GreenScreenComponent
                            photo_file_name={props.photo_file_name}
                            product_type={props.product_type}
                            site_id={site_id}
                            primary_color_4={primary_color_4}
                            background_color_2={background_color_2}
                            messages={messages}
                            effectData={props.product.productdetail.effects}
                            effectFileNameFor={props.effectFileNameFor}
                            effectFileNameBehind={props.effectFileNameBehind}
                            // setMessages={setMessages} // if it's a class-based component
                            setMessages={setMessages}  // if it's a functional component with hooks
                            user_id={props.user_id}
                            photo_id={props.photo_id}
                            closepopup_effect={closepopup_effect}// if it's a class-based component
                            // closepopup_effect={closePopupFunction}  // if it's a functional component with hooks
                            t={props.t} // your translation function
                        />
                        <Grid item lg={12} className="card-footer-item Number">
                            <ProductProperties
                                productVariationGroups={props.product.productdetail.product_variation_groups}
                                handleVariationChangePhoto={productVariation}
                            />
                        </Grid>
                        <Grid item lg={12} className="card-footer-item Number">
                            <ProductPrintType
                              productPrintType={props.product.productdetail.afdruk_type}
                              handlePrintType={printType}
                            />
                        </Grid>
                        {/*{bijsnijden_fotos === 'true' &&*/}
                        
                        {/*//Dit moet een los onderdeel worden.*/}
                        {/*    <>*/}
                        {/*        <Button*/}
                        {/*            style={{*/}
                        {/*                color: `${primary_color_2}`*/}
                        {/*            }}*/}
                        {/*            className="btn btn-light form-control btn-layout"*/}
                        {/*            onClick={() => setMessages(prevState => ({*/}
                        {/*                ...prevState,*/}
                        {/*                messageCrop: !messages.messageCrop*/}
                        {/*            }))}>*/}
                        {/*            {props.t('Crop photo')}*/}
                        {/*        </Button>*/}
                        {/*        {messages.messageCrop ?*/}
                        {/*            <PopUpComponent*/}
                        {/*                style={{*/}
                        {/*                    width: `100%!`,*/}
                        {/*                    height: `100%`*/}
                        {/*                }}*/}
                        {/*                primary_color_4={primary_color_4}*/}
                        {/*                background_color_2={background_color_2}*/}
                        {/*                // border_radius={border_radius}*/}
                        {/*                text={<>test</>}*/}
                        {/*                content={*/}
                        {/*                    <PhotoCropComponent*/}
                        {/*                        photo_file_name={props.photo_file_name}*/}
                        {/*                        product_format={props.product_format}*/}
                        {/*                        photo_id={props.photo_id}*/}
                        {/*                        folder_id={props.folder_id}*/}
                        {/*                        site_id={site_id}*/}
                        {/*                        effectFor={effectFor}*/}
                        {/*                    />*/}
                        {/*                }*/}
                        {/*                // btn1={props.t('cart')}*/}
                        {/*                // href='/cart'*/}
                        {/*                btn2={props.t('Continue Shopping')}*/}
                        {/*                closePopup={closePopup}*/}
                        {/*            />*/}
                        {/*            : null}*/}
                        {/*    </>*/}
                        
                        {/*}*/}
                    </Grid>
                    <Grid container>
                        <Grid item lg={6} sm={12} xs={12} className="card-footer-item SelectOption">
                            <ProductColorSelector
                                product_colors={props.product_colors}
                                handleColorChange={props.handleColorChange}
                                photo_file_name={props.photo_file_name}
                                handleColorChangePhoto={handleColorChangePhoto}
                                t={props.t}
                                product_id={props.product_id}
                            />
                        </Grid>
                        <Grid item lg={6} sm={12} xs={12} className="card-footer-item Number">
                            {props.product_type !== "download" &&
                                props.product_type !== "groepsfoto download" && props.product_type !== "totaalpakket" && (

                                    <FormGroup
                                        style={{
                                            width: `98%`,
                                        }}
                                    >
                                        <FormLabel>{props.t("shoppingcart:Quantity")}</FormLabel>
                                        <QuantityControl
                                            primaryColor={primary_color_4} // replace with actual color
                                            backgroundColor={background_color_2} // replace with actual color
                                            productId={props.product_id}
                                            quantity={quantity} // replace with actual quantity
                                            changeQuantity={changeQuantity} // replace with actual function
                                        />
                                    </FormGroup>

                                )}
                        </Grid>
                    </Grid>
                </div>
            </div>
        );
    }

    if (props.product_type === "pakket") {

        // Define the style object with the random height and white background
        return (
            <div className="card-body-and-footer">
                <Grid item lg={12} className="card-body">
                    <Grid container direction="row" alignItems="center" spacing={1}>
                        {props.pakket_data.map((data, index) => {
                            // console.log(data);
                            return photo_files.photo_file_name == null ? (
                                <Grid
                                    item
                                    key={data.product_id}
                                    xs={4}
                                    md
                                    lg={props.hide_category_side_bar !== 'true' ? 3 : undefined} // Conditional logic here
                                    className="bottom-card no-padding align-self-bottom"
                                >
                                    <PhotoComponent
                                        groepsfoto={
                                            data.productdetail.product_type === "groepsfoto" ||
                                            data.productdetail.product_type === "groepsfoto download"
                                                ? true
                                                : false
                                        }
                                        Index={index}
                                        updatePhotoFileName={props.updatePhotoFileName}
                                        file_changed={!photo_files.file_changed}
                                        product_combivel_id={data.productdetail.combivel_id}
                                        product_type={props.product_type}
                                        pakket_selectie_alle_inlogs={props.product.productdetail.pakket_selectie_alle_inlogs}
                                        pakket_selectie={props.product.productdetail.pakket_selectie}
                                        photo_id={data.productdetail.photo_id}
                                        child_product_type={data.productdetail.product_type}
                                        child_product_file={data.productdetail.afbeelding}
                                        product_id={props.product_id}
                                        login_name={props.login_name}
                                        product_name={data.productdetail.naam}
                                        class_id={props.class_id}
                                        product_child_id={data.product_id}
                                        product_child_formaat={data.productdetail.product_format}
                                        product_child_colors={data.productdetail.kleuren}
                                        photo_file_name={data.productdetail.product_file}
                                        product_color={product_color}
                                        folder_id={data.productdetail.folder_id}
                                        type={props.type}
                                        effect_id={effects.effect_id}
                                        effect_file_name={effects.effect_file_name}
                                        effect_file_id_for={effectFor.effect_for_id}
                                        effect_voor_achter={effects.voor_achter}
                                        photoType={data.productdetail.photoType}
                                    />
                                </Grid>
                            ) : (
                                <Grid
                                    item
                                    key={data.product_id}
                                    xs={4}
                                    md={3}
                                    lg={3}
                                    className=" bottom-card no-padding align-self-bottom"
                                >
                                    <PhotoComponent
                                        Index={index}
                                        updateIndex={props.updateIndex}
                                        updatePhotoFileName={props.updatePhotoFileName}
                                        login_name={props.login_name}
                                        file_changed={photo_files.file_changed}
                                        product_combivel_id={data.productdetail.product_combivel_id}
                                        product_type={props.product_type}
                                        product_id={props.product_id}
                                        photo_id={photo_files.photo_id}
                                        product_image={props.product_image}
                                        photo_file_name={photo_files.photo_file_name}
                                        product_color={product_color}
                                        folder_id={props.folder_id}
                                        type={props.type}
                                        effect_id={effects.effect_id}
                                        effect_voor_achter={effects.voor_achter}
                                        effect_file_id_for={effectFor.effect_for_id}
                                        photoType={data.productdetail.photoType}
                                    />
                                </Grid>
                            );
                        })}
                    </Grid>
                </Grid>
                <Grid item lg={12} md={12} className="card-footer-item">
                    <Grid container>
                        <Grid item lg={12} md={12} className="col-lg-12 col-md-12 col-12">
                            {
                                props.product_description !== null && (
                                    <Typography component="div" align="left">
                                        {ReactHtmlParser(props.product_description)}
                                    </Typography>
                                )
                            }

                            {hide_category_side_bar !== 'true' && (
                                <>
                                    <p className="font-bold">
                                        {props.t("productdetailComponent:Package contents")}
                                    </p>
                                    <div className="pakket-list">
                                        {props.pakket_data.map((data) => {
                                            return <p key={data.product_id}>{data.productdetail.naam}</p>;
                                        })}
                                    </div>
                                </>
                            )}
                        </Grid>
                    </Grid>
                    <Grid container>
                        <GreenScreenComponent
                            photo_file_name={props.photo_file_name}
                            product_type={props.product_type}
                            site_id={site_id}
                            primary_color_4={primary_color_4}
                            background_color_2={background_color_2}
                            messages={messages}
                            effectData={props.product.productdetail.effects}
                            effectFileNameFor={props.effectFileNameFor}
                            effectFileNameBehind={props.effectFileNameBehind}
                            // setMessages={setMessages} // if it's a class-based component
                            setMessages={setMessages}  // if it's a functional component with hooks
                            user_id={props.user_id}
                            photo_id={props.photo_id}
                            closepopup_effect={closepopup_effect}// if it's a class-based component
                            // closepopup_effect={closePopupFunction}  // if it's a functional component with hooks
                            t={props.t} // your translation function
                        />
                        {/*<Grid item lg={12} className="card-footer-item Number">*/}
                        {/*  {props.photo_file_name != null ? (*/}
                        {/*      fileNameSplit[1] === "png" && props.product_type!=='divers' && site_id!=='180' ? (*/}
                        {/*          <>*/}
                        {/*            <Button*/}
                        {/*                style={{*/}
                        {/*                  color: `${primary_color_2}`,*/}
                        {/*                  backgroundColor: `${background_color_2}`,*/}
                        {/*                }}*/}
                        {/*                className="btn btn-light form-control btn-layout"*/}
                        {/*                onClick={() =>*/}
                        {/*                    setMessages((prevState) => ({*/}
                        {/*                      ...prevState,*/}
                        {/*                      message: !messages.message,*/}
                        {/*                    }))*/}
                        {/*                }*/}
                        {/*            >*/}
                        {/*              {props.t("shoppingcart:Background")}*/}
                        {/*            </Button>*/}
                        {/*            {messages.message ? (*/}
                        {/*                <PopUpComponent*/}
                        {/*                    text={*/}
                        {/*                      <Alert severity="info">*/}
                        {/*                        {props.t("shoppingcart:Background")}*/}
                        {/*                      </Alert>*/}
                        {/*                    }*/}
                        {/*                    content={*/}
                        {/*                      <EffectComponent*/}
                        {/*                          user_id={props.user_id}*/}
                        {/*                          photo_id={props.photo_id}*/}
                        {/*                          product_type={props.product_type}*/}
                        {/*                          type={'achter'}*/}
                        {/*                          closepopup_effect={closepopup_effect}*/}
                        {/*                      />*/}
                        {/*                    }*/}
                        {/*                    btn2={props.t("shoppingcart:Continue Shopping")}*/}
                        {/*                    closePopup={closepopup_effect}*/}
                        {/*                />*/}
                        {/*            ) : null}*/}
                        {/*          </>*/}
                        {/*      ) : (*/}
                        {/*          <></>*/}
                        {/*      )*/}
                        {/*  ) : (*/}
                        {/*      <></>*/}
                        {/*  )}*/}
                        {/*</Grid>*/}
                        {/*<Grid item lg={12} className="card-footer-item Number">*/}
                        {/*  {props.photo_file_name != null ? (*/}
                        {/*      props.product_type!=='divers' && site_id==='124' ? (*/}
                        {/*          <>*/}
                        {/*            <Button*/}
                        {/*                style={{*/}
                        {/*                  color: `${primary_color_2}`,*/}
                        {/*                  backgroundColor: `${background_color_2}`,*/}
                        {/*                }}*/}
                        {/*                className="btn btn-light form-control btn-layout"*/}
                        {/*                onClick={() =>*/}
                        {/*                    setMessages((prevState) => ({*/}
                        {/*                      ...prevState,*/}
                        {/*                      message: !messages.message,*/}
                        {/*                    }))*/}
                        {/*                }*/}
                        {/*            >*/}
                        {/*              {props.t("shoppingcart:Overlay")}*/}
                        {/*            </Button>*/}
                        {/*            {messages.message ? (*/}
                        {/*                <PopUpComponent*/}
                        {/*                    text={*/}
                        {/*                      <Alert severity="info">*/}
                        {/*                        {props.t("shoppingcart:Overlay")}*/}
                        {/*                      </Alert>*/}
                        {/*                    }*/}
                        {/*                    content={*/}
                        {/*                      <EffectComponent*/}
                        {/*                          user_id={props.user_id}*/}
                        {/*                          photo_id={props.photo_id}*/}
                        {/*                          product_type={props.product_type}*/}
                        {/*                          type={'voor'}*/}
                        {/*                          closepopup_effect={closepopup_effect}*/}
                        {/*                      />*/}
                        {/*                    }*/}
                        {/*                    btn2={props.t("shoppingcart:Continue Shopping")}*/}
                        {/*                    closePopup={closepopup_effect}*/}
                        {/*                />*/}
                        {/*            ) : null}*/}
                        {/*          </>*/}
                        {/*      ) : (*/}
                        {/*          <></>*/}
                        {/*      )*/}
                        {/*  ) : (*/}
                        {/*      <></>*/}
                        {/*  )}*/}
                        {/*</Grid>*/}
                        <Grid item lg={12} sm={12} xs={12} className="card-footer-item SelectOption">
                            <ProductPrintType
                              productPrintType={props.product.productdetail.afdruk_type}
                              handlePrintType={printType}
                            />
                        </Grid>
                        <Grid item lg={6} sm={12} xs={12} className="card-footer-item SelectOption">
                            <ProductColorSelector
                                product_colors={props.product_colors}
                                photo_file_name={props.photo_file_name}
                                handleColorChange={props.handleColorChange}
                                handleColorChangePhoto={handleColorChangePhoto}
                                t={props.t}
                                product_id={props.product_id}
                            />
                        </Grid>
                        <Grid item lg={6} sm={12} xs={12} className="card-footer-item Number">
                            <FormGroup
                                style={{
                                    width: `98%`,
                                }}
                            >
                                <FormLabel>{props.t("shoppingcart:Quantity")}</FormLabel>
                                <QuantityControl
                                    primaryColor={primary_color_4} // replace with actual color
                                    backgroundColor={background_color_2} // replace with actual color
                                    productId={props.product_id}
                                    quantity={quantity} // replace with actual quantity
                                    changeQuantity={changeQuantity} // replace with actual function
                                />
                            </FormGroup>
                        </Grid>
                    </Grid>
                </Grid>
            </div>
        );
    }
}

export default React.memo(
    withTranslation(["productdetailComponent", "shoppingcart", "message"])(
        ProductdetailComponent
    )
);
